import { render, staticRenderFns } from "./CoreFullscreen.vue?vue&type=template&id=21a3ebf4&scoped=true&"
import script from "./CoreFullscreen.vue?vue&type=script&lang=js&"
export * from "./CoreFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./CoreFullscreen.vue?vue&type=style&index=0&id=21a3ebf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a3ebf4",
  null
  
)

component.options.__file = "CoreFullscreen.vue"
export default component.exports